import React from 'react';


const Head = () => {
  return (
    <div className="top-header">
      <div className="contact-info">
        {/* <a href="tel:+919876543210" className="call-btn">📞 +91 9876543210</a> */}
        <span className="email"> 46/46A, Doodh Mandi road, near Muslim Musafir Khana, opposite Hotel Kaveri, Cash and Pay Colony, Charbagh, Lucknow, Uttar Pradesh 226004</span>
       
      </div>
      <div className="social-icons">
        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
          <i className="fa fa-facebook-f"></i>
        </a>
        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
          <i className="fa fa-instagram"></i>
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
          <i className="fa fa-twitter"></i>
        </a>

        <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
          <i className="fa fa-youtube-play"></i>
        </a>
      </div>
    </div>
  );
};

export default Head;
